function eventDelegate(parentSelector, targetSelector, events, foo) {
  // 触发执行的函数
  function triFunction(e) {
    // 兼容性处理
    var event = e || window.event;

    // 获取到目标阶段指向的元素
    var target = event.target || event.srcElement;

    // 获取到代理事件的函数
    var currentTarget = event.currentTarget;

    // 处理 matches 的兼容性
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function (s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(s);
          var i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        };
    }

    // 遍历外层并且匹配
    while (target && target !== currentTarget) {
      // 判断是否匹配到我们所需要的元素上
      if (target && target.matches(targetSelector)) {
        var sTarget = target;
        // 执行绑定的函数，注意 this
        foo.call(sTarget, Array.prototype.slice.call(arguments));
      }

      target = target && target.parentNode;
    }
  }

  // 如果有多个事件的话需要全部一一绑定事件
  events.split(".").forEach(function (evt) {
    // 多个父层元素的话也需要一一绑定
    Array.prototype.slice.call(document.querySelectorAll(parentSelector)).forEach(function ($p) {
      $p.addEventListener(evt, triFunction);
    });
  });
}

function parseQueryString(url) {
  var pos;
  var obj = {};
  if ((pos = url.indexOf("?")) !== -1) {
    var param = url.substring(pos + 1, url.length);
    var paramArr = param.split("&");
    var keyValue = [];
    for (var i = 0, l = paramArr.length; i < l; i++) {
      keyValue = paramArr[i].split("=");
      obj[keyValue[0]] = keyValue[1];
    }
  }
  return obj;
}

function report(obj, extParam) {
  var obj = obj || {};
  var oUrl = parseQueryString(location.search);

  var pro = obj.pro;

  if (!window.YA) {
    return false;
  }

  var source = {
    pro: pro, // 产品给的
    pas: YA.cookie.get("username") || "",
    yyuid: YA.cookie.get("yyuid") || "",
    pageType: "root",
    rso: oUrl.rso || "",
    rso_desc: "",
    eid: "",
    eid_desc: "",
  };

  for (var property in obj) {
    source[property] = obj[property];
  }

  window.ya = new YA(source.pro, source.pas, {
    pageType: source.pageType,
    yyuid: source.yyuid,
  });

  if (extParam) {
    ya.setExtParam(extParam);
  }

  ya.reportProductStartUp({
    pro: source.pro,
    rso: source.rso,
    rso_desc: source.rso_desc,
  });

  ya.startProductHeartbeat({
    pro: source.pro,
    rso: source.rso,
    rso_desc: source.rso_desc,
  });

  if (source.eid) {
    ya.reportProductEvent({
      eid: source.eid,
    });
  }

  // 点击上报
  eventDelegate("body", ".clickstat", "click", function () {
    var eid = this.getAttribute("eid");

    if (eid) {
      ya.reportProductEvent({
        eid: eid,
      });
    }
  });
}

function getScriptCache(url, callback) {
  var head = document.getElementsByTagName("head")[0] || document.documentElement;
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.charset = "utf-8";
  script.src = url;
  script.onload = script.onreadystatechange = function () {
    if (!script.readyState || /loaded|complete/.test(script.readyState)) {
      callback && callback();
      script.onload = script.onreadystatechange = null;
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    }
  };
  head.insertBefore(script, null);
}

function addHandler(element, type, handler) {
  return element.addEventListener
    ? element.addEventListener(type, handler, false)
    : element.attachEvent("on" + type, handler);
}

function resetReport() {
  var _hmt = window.yaReportArr || [];
  if (_hmt.length) {
    for (var i = 0; i < _hmt.length; i++) {
      window.ya && ya.reportProductEvent(_hmt[i]);
    }
  }

  window.yaReportArr = [];
  window.yaReportArr.push = function (obj) {
    if (window.ya) {
      if (obj.actionType && ya[obj.actionType]) {
        ya[obj.actionType](obj.param);
      } else {
        ya.reportProductEvent(obj);
      }
    }
  };
}

let getYajs = (function () {
  let btn = true;

  return function (obj, extParam) {
    if (btn) {
      btn = false;
      getScriptCache("https://static-jw.msstatic.com/rp/v2/ya-huya.finall.min.js", function () {
        report(obj, extParam);
        resetReport();
      });
    }
  };
})();

function yaReport(obj, extParam) {
  getYajs(obj, extParam);
}

export default yaReport;
